export default "__VITE_ASSET__0E5W75jR__"